/* The runtime measures the drawer gutter before opening an overlay.
   Refresh it only while visible; closed drawers need no layout measurement. */
(function(){
 'use strict';
 var root=document.documentElement;
 function syncGutter(){
  var cart=document.getElementById('CartDrawer');
  if(!cart||!cart.open)return;
  var gutter=Math.max(0,window.innerWidth-root.getBoundingClientRect().width);
  root.style.setProperty('--meriavo-cart-gutter',gutter+'px');
 }
 function setup(){
  var dialog=document.getElementById('InfoModal');
  if(!dialog)return;
  function reset(){
   if(!dialog.open)return;
   dialog.scrollTop=0;
   var body=dialog.querySelector('.info-body');
   if(body)body.scrollTop=0;
  }
  new MutationObserver(reset).observe(dialog,{attributes:true,attributeFilter:['open']});
  reset();
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup,{once:true});
 else setup();
 window.addEventListener('resize',syncGutter,{passive:true});
 window.addEventListener('pageshow',syncGutter);
})();
